"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsPagerContainer = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var SearchFilters_1 = require("icf-search-client-data/lib/SearchFilters");
var Events_1 = require("icf-search-client-shared/lib/services/Events");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var Pager_1 = require("./Pager");
var PagerSmall_1 = require("./PagerSmall");
var PerformerDataSourceContextProps_1 = require("./PerformerDataSourceContextProps");
var maxPageNumber = 99;
var SearchResultsPagerContainer = /** @class */ (function (_super) {
    __extends(SearchResultsPagerContainer, _super);
    function SearchResultsPagerContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchResultsPagerContainer.prototype._getPageRange = function () {
        var _a = this.props, pageNumber = _a.pageNumber, resultsContext = _a.resultsContext, resultsPerPage = _a.resultsPerPage;
        var totalItemCount = resultsContext.totalItemCount;
        var numPages = Math.min(Math.ceil(totalItemCount / resultsPerPage), maxPageNumber);
        var numBefore = pageNumber - 1;
        var numAfter = numPages - pageNumber;
        if (numBefore < 3 && numAfter < 3) {
            return {
                start: Math.max(1, pageNumber - numBefore),
                end: Math.min(numPages, pageNumber + numAfter),
            };
        }
        else if (numBefore < 3) {
            // numAfter >= 3
            return {
                start: Math.max(1, pageNumber - numBefore),
                end: Math.min(numPages, pageNumber + 6 - numBefore),
            };
        }
        else if (numAfter < 3) {
            // numBefore >= 3
            return {
                start: Math.max(1, pageNumber - 6 + numAfter),
                end: Math.min(numPages, pageNumber + numAfter),
            };
        }
        else {
            // numBefore and numAfter >= 3
            return {
                start: Math.max(1, pageNumber - 3),
                end: Math.min(numPages, pageNumber + 3),
            };
        }
    };
    SearchResultsPagerContainer.prototype._getClickTrackingContext = function (destinationPage) {
        return {
            currentPage: this.props.pageNumber,
            destinationPage: destinationPage,
            fallback: this.props.resultsContext.isFallback,
            searchDataOptions: (0, PerformerDataSourceContextProps_1.prepareTrackingQueryOptions)(this.props.dataQueryOptions),
        };
    };
    SearchResultsPagerContainer.prototype._pageNextClicked = function (pageNum) {
        this.props.eventPublisher &&
            this.props.eventPublisher.send(Events_1.Events.pageNextClick, this._getClickTrackingContext(pageNum), undefined, false);
        this.props.statsdClient && this.props.statsdClient.count("pager.nextClicked");
        this.props.emitTrackingEvent("icfClick", "pager", "label=next");
    };
    SearchResultsPagerContainer.prototype._pagePrevClicked = function (pageNum) {
        this.props.eventPublisher &&
            this.props.eventPublisher.send(Events_1.Events.pagePrevClick, this._getClickTrackingContext(pageNum), undefined, false);
        this.props.statsdClient && this.props.statsdClient.count("pager.prevClicked");
        this.props.emitTrackingEvent("icfClick", "pager", "label=prev");
    };
    SearchResultsPagerContainer.prototype._pageClicked = function (pageNum) {
        this.props.eventPublisher &&
            this.props.eventPublisher.send(Events_1.Events.pageNumClick, this._getClickTrackingContext(pageNum), undefined, false);
        this.props.statsdClient && this.props.statsdClient.count("pager.pageClicked");
        this.props.emitTrackingEvent("icfClick", "pager", "label=".concat(pageNum));
    };
    SearchResultsPagerContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, getPageLinkTo = _a.getPageLinkTo, pageNumber = _a.pageNumber;
        var breakpoint = this.props.layout.breakpoint;
        var isAvailable = !this.props.resultsContext.isFallback && !this.props.resultsContext.isLoadingInitialResults;
        if ((!isAvailable || !getPageLinkTo) && (0, SearchFilters_1.getAdvancedFilterArray)(this.props.dataQueryOptions.filters).length === 0) {
            return null;
        }
        var pageRange = this._getPageRange();
        if (pageRange.start === pageRange.end) {
            return null;
        }
        else if (breakpoint === "small") {
            var canGoBack = pageNumber > pageRange.start;
            var canGoForward = pageNumber < pageRange.end;
            var previousPageNumber_1 = canGoBack ? pageNumber - 1 : undefined;
            var nextPageNumber_1 = canGoForward ? pageNumber + 1 : undefined;
            return (React.createElement(PagerSmall_1.PagerSmall, { prevPageLinkTo: canGoBack ? getPageLinkTo(previousPageNumber_1) : undefined, nextPageLinkTo: canGoForward ? getPageLinkTo(nextPageNumber_1) : undefined, onPrevClick: function () { return _this._pagePrevClicked(previousPageNumber_1); }, onNextClick: function () { return _this._pageNextClicked(nextPageNumber_1); } }));
        }
        return (React.createElement(Pager_1.Pager, { getPageLinkTo: getPageLinkTo, currentPage: pageNumber, onPageClick: function (num) { return _this._pageClicked(num); }, onNextClick: function (num) { return _this._pageNextClicked(num); }, onPrevClick: function (num) { return _this._pagePrevClicked(num); }, pageRange: this._getPageRange() }));
    };
    SearchResultsPagerContainer = __decorate([
        (0, Ioc_1.connectContextsToProps)({
            // @ts-ignore -- Fix typing for contexts with undefined
            eventPublisher: Contexts_1.IEventPublisherContext,
            layout: Contexts_1.ILayoutContext,
            // @ts-ignore -- Fix typing for contexts with undefined
            statsdClient: Contexts_1.IStatsdClientContext,
            xmentService: Contexts_1.IXmentServiceContext,
        })
    ], SearchResultsPagerContainer);
    return SearchResultsPagerContainer;
}(React.Component));
exports.SearchResultsPagerContainer = SearchResultsPagerContainer;
//# sourceMappingURL=SearchResultsPagerContainer.js.map